import styled from "styled-components";
import { colors } from "../../../theme/colors";
import { Typography, Grid, Button } from "@mui/material";

export const PostsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
`;

export const PostsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  @media (min-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const PostCard = styled.div`
  background: ${colors.white.main};
  border-radius: 38px 0px 38px 0px;
  min-height: 525px;
  height: max-content;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  &:hover {
    transform: translateY(-8px);
  }
`;

export const PostImage = styled.div`
  padding: 1.5rem 1.5rem 0 1.5rem;
  background: white;

  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    object-position: center;
    border-radius: 38px 0px 38px 0px;
    transition: transform 0.3s ease;
    display: block;
  }
`;

export const PostContent = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  height: calc(100% - 200px);
  min-height: 250px;
`;

export const PostTitle = styled.h3`
  font-size: 1.3rem;
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 0rem;
  margin-top: 0rem;
  line-height: 24px;
`;

export const PostDescription = styled.p`
  color: ${colors.gray.textLight};
  line-height: 22px;
  margin-bottom: 1rem;
  flex-grow: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 1rem;
`;

export const PostDate = styled.div`
  font-size: 0.875rem;
  color: #718096;
  margin-bottom: 1rem;
  font-weight: 500;
`;

export const PostButton = styled(Button)`
  && {
    width: 75%;
    margin: 0 auto;
    background-color: ${colors.secondary};
    color: ${colors.primary};
    border-radius: 8px;
    padding: 0.5rem 2.5rem;
    text-transform: none;
    font-weight: bold;
    font-size: 1rem;
    transition: all 0.3s ease;

    &:hover {
      background-color: #38a8bb;
      transform: translateY(-2px);
    }
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`;

export const LoadingSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ErrorContainer = styled.div`
  text-align: center;
  padding: 2rem;
`;

export const ErrorBox = styled.div`
  background: #003865;
  border-radius: 12px;
  padding: 1.5rem;
  max-width: 400px;
  margin: 0 auto;

  p {
    color: ${colors.white.main};
    margin-bottom: 1rem;
    font-weight: 500;
  }
`;

export const RetryButton = styled.button`
  background: #e53e3e;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #c53030;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    gap: 0.25rem;
  }
`;

export const PageNumbersContainer = styled.div`
  display: flex;
  gap: 0.25rem;
`;

export const PaginationButton = styled.button`
  padding: 0.75rem 1rem;
  background: ${colors.primary};
  color: ${colors.secondary};
  border: none !important;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  min-width: 44px;

  &:hover:not(.disabled) {
    background: ${colors.primary};
    border-color: ${colors.primary};
  }

  &.active {
    background: ${colors.primary};
    border-color: ${colors.primary};
    color: white;
  }

  &.disabled {
    background: ${colors.primary};
    color: ${colors.secondary};
    cursor: not-allowed;
    border-color: ${colors.primary};
  }

  @media (max-width: 480px) {
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    min-width: 36px;
  }
`;

export const PaginationInfo = styled.div`
  text-align: center;
  font-size: 0.875rem;
  color: #718096;
  font-weight: 500;
`;
